import React from "react";
import Link from "next/link";
import {
  BiBrain,
  BiChip,
  BiData,
  BiTrendingUp,
  BiShield,
  BiCog,
  BiTargetLock,
  BiAnalyse,
  BiNetworkChart,
  BiBot,
  BiConversation,
  BiLaptop
} from "react-icons/bi";
import { useTranslations } from '../../locales/useTranslations';

const KiTopics = () => {
  const { t } = useTranslations();
  const topics = [
    {
      icon: BiBrain,
      title: t('ki_topics_title1'),
      description: t('ki_topics_description1'),
      color: "linear-gradient(135deg, #59bd65 0%, #2e7d32 100%)"
    },
    {
      icon: BiLaptop,
      title: t('ki_topics_title2'),
      description: t('ki_topics_description2'),
      color: "linear-gradient(135deg, #66bb6a 0%, #59bd65 50%, #388e3c 100%)"
    },
    {
      icon: BiCog,
      title: t('ki_topics_title3'),
      description: t('ki_topics_description3'),
      color: "linear-gradient(135deg, #4CAF50 0%, #59bd65 30%, #2e7d32 100%)"
    },
    {
      icon: BiConversation,
      title: t('ki_topics_title4'),
      description: t('ki_topics_description4'),
      color: "linear-gradient(135deg, #59bd65 0%, #81c784 50%, #66bb6a 100%)"
    },
    {
      icon: BiData,
      title: t('ki_topics_title5'),
      description: t('ki_topics_description5'),
      color: "linear-gradient(135deg, #388e3c 0%, #59bd65 50%, #4CAF50 100%)"
    },
    {
      icon: BiTrendingUp,
      title: t('ki_topics_title6'),
      description: t('ki_topics_description6'),
      color: "linear-gradient(135deg, #59bd65 0%, #66bb6a 30%, #2e7d32 100%)"
    },
    {
      icon: BiShield,
      title: t('ki_topics_title7'),
      description: t('ki_topics_description7'),
      color: "linear-gradient(135deg, #4CAF50 0%, #59bd65 40%, #388e3c 100%)"
    },
    {
      icon: BiNetworkChart,
      title: t('ki_topics_title8'),
      description: t('ki_topics_description8'),
      color: "linear-gradient(135deg, #59bd65 0%, #81c784 50%, #66bb6a 100%)"
    },
    {
      icon: BiBot,
      title: t('ki_topics_title9'),
      description: t('ki_topics_description9'),
      color: "linear-gradient(135deg, #2e7d32 0%, #59bd65 60%, #4CAF50 100%)"
    },
    {
      icon: BiTargetLock,
      title: t('ki_topics_title10'),
      description: t('ki_topics_description10'),
      color: "linear-gradient(135deg, #59bd65 0%, #66bb6a 40%, #388e3c 100%)"
    },
    {
      icon: BiAnalyse,
      title: t('ki_topics_title11'),
      description: t('ki_topics_description11'),
      color: "linear-gradient(135deg, #388e3c 0%, #59bd65 50%, #66bb6a 100%)"
    },
    {
      icon: BiChip,
      title: t('ki_topics_title12'),
      description: t('ki_topics_description12'),
      color: "linear-gradient(135deg, #59bd65 0%, #81c784 30%, #4CAF50 100%)"
    }
  ];

  return (
    <section className="features-card-section pt-100 pb-70 ki-topics-section">
      {/* Hintergrund-Dekoration */}
      <div className="ki-topics-decoration ki-topics-decoration--top-left"></div>
      <div className="ki-topics-decoration ki-topics-decoration--bottom-right"></div>

      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="section-title text-center mb-5">
              <span className="ki-topics-header__badge">
                {t('ki_topics_title')}
              </span>
              <h2 className="ki-topics-header__title">
                {t('ki_topics_description')}
              </h2>
              <p className="ki-topics-header__description">
                {t('ki_topics_description')}
              </p>
            </div>
          </div>
        </div>

        <div className="row">
          {topics.map((topic, index) => {
            const IconComponent = topic.icon;
            return (
              <div
                key={index}
                className="col-lg-4 col-md-6 mb-4"
                data-aos="fade-up"
                data-aos-delay={100 + (index * 50)}
                data-aos-duration="1200"
              >
                <div className="ki-topic-card">
                  {/* Icon Container */}
                  <div 
                    className="ki-topic-card__icon"
                    style={{ background: topic.color }}
                  >
                    <IconComponent className="ki-topic-card__icon-svg" />
                  </div>

                  {/* Content */}
                  <h3 className="ki-topic-card__title">
                    {topic.title}
                  </h3>
                  <p className="ki-topic-card__description">
                    {topic.description}
                  </p>

                  {/* Hover Effect Overlay */}
                  <div className="ki-topic-card__overlay"></div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Call to Action */}
        <div className="row mt-5">
          <div className="col-lg-12">
            <div className="text-center">
              <div className="ki-topics-cta">
                {/* Dekorative Elemente */}
                <div className="ki-topics-cta__decoration ki-topics-cta__decoration--top-right"></div>
                <div className="ki-topics-cta__decoration ki-topics-cta__decoration--bottom-left"></div>

                <h3 className="ki-topics-cta__title">
                  {t('ki_topics_cta_title')}
                </h3>
                <p className="ki-topics-cta__description">
                  {t('ki_topics_cta_description')}
                </p>
                <Link href="/kontakt" className="ki-topics-cta__button">
                  {t('ki_topics_cta_button')}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default KiTopics;
